export default __webpack_public_path__ + "static/MediaContentThirtTeen-d253a35de7fb18c5f19782264feb51c6.webp";